import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const urls = {
  allVehicles: 'vehicle/all',
  allBuySellVehicles: 'buysell/all',
  getBuySellVehicleByvehilceId: 'buysell/getBuySellDetailsByVehicleId',
  updateBuySellVehicleStatus: 'buysell/updateStatus',
  updateBuySellVehicleCustomerDetails: 'buysell/updateCustomerDetails',
  checkVehicleUrl: '/buySell/vehicleExistanceCheckApi',
  addSellvehicle: '/buySell/addToSellVehicle',
  uploadVehicleImages: '/vehicle/uploadVehicleImages',
  uploadVehicleCustomerImage: '/buysell/uploadPanAadharImage',
  updateSellVehicle: '/buySell/updateSellVehicle',
  deleteVehicle: '/buySell'
};

export const getAllVehicleApi = createAsyncThunk('serviceplug/getAllVehicleApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.allVehicles}`,
      method: 'post',
      data: params
    });
    const data = await response.data.result;

    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getAllBuySellVehicleApi = createAsyncThunk(
  'serviceplug/getAllBuySellVehicleApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.allBuySellVehicles}`,
        method: 'post',
        data: params
      });
      const data = await response.data.result;

      return data;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getBuySellVehicleByvehilceIdApi = createAsyncThunk(
  'serviceplug/getBuySellVehicleByvehilceIdApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(urls.getBuySellVehicleByvehilceId, { params });
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateBuySellVehicleStatusApi = createAsyncThunk(
  'serviceplug/updateBuySellVehicleStatusApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.updateBuySellVehicleStatus}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      return data;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const updateBuySellVehicleCustomerDetailsApi = createAsyncThunk(
  'serviceplug/updateBuySellVehicleCustomerDetailsApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.updateBuySellVehicleCustomerDetails}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      return data;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const vehicleExistanceCheckApi = createAsyncThunk(
  'buySell/vehicleExistanceCheckApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: urls.checkVehicleUrl,
        method: 'post',
        data: params
      });
      const data = await response.data;
      if (data) {
        return data.result;
      }
    } catch (err) {
      console.log(err, 'errors');
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const addSellvehicleApi = createAsyncThunk('buySell/addSellvehicleApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: urls.addSellvehicle,
      method: 'post',
      data: params
    });
    const data = await response.data;
    if (data) {
      return data.result;
    }
  } catch (err) {
    console.log(err);
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const uploadVehicleImagesApi = createAsyncThunk('user/uploadVehicleImagesApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.uploadVehicleImages}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    console.log(err, 'asldksw');
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const uploadVehicleCustomerImageApi = createAsyncThunk(
  'user/uploadVehicleCustomerImageApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.uploadVehicleCustomerImage}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      console.log(err, 'asldksw');
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const updateSellVehicleApi = createAsyncThunk('user/updateSellVehicleApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateSellVehicle}`,
      method: 'put',
      data: params
    });
    const data = await response.data;
    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const deleteVehicleApi = createAsyncThunk('serviceplug/deleteVehicleApi', async (params, thunkApi) => {
  try {
    const response = await axios.delete(`${urls.deleteVehicle}/${params.vehicleId}`);
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});
